(function ($) {
  var $window, $pageNav, $widgetTitle;

  $(function () {
    ($window = $(window)),
      ($pageNav = $(".page-nav")),
      ($widgetTitle = $(".page-nav .widget-title"));

    $window.resize(
      debounce(function () {
        if ($window.width() <= 992) {
          initMobile();
        } else {
          destroyMobile();
        }
      }, 300)
    );

    $window.trigger("resize");
  });

  function initMobile() {
    if ($pageNav.hasClass("mobile")) return;
    $pageNav.addClass("mobile collapsed");
    $widgetTitle.click(function () {
      $pageNav.toggleClass("collapsed");
    });
  }

  function destroyMobile() {
    if (!$pageNav.hasClass("mobile")) return;
    $pageNav.removeClass("mobile collapsed");
    $widgetTitle.off("click");
  }
})(jQuery);
